import type { ReactNode } from 'react';

/**
 * Hover label for the image tool-rail buttons. Mirrors the NavBar tooltip: a
 * CSS-only `group-hover` chip that fades in to the right of the button. Wrap a
 * single rail button so the chip aligns to it.
 */
export const RailTooltip = ({
	label,
	children,
}: {
	label: string;
	children: ReactNode;
}) => (
	<div className="group relative flex">
		{children}
		<span
			className="pointer-events-none absolute top-1/2 left-full ml-2
				-translate-y-1/2 rounded-md bg-gray-800 px-2 py-1 text-sm
				whitespace-nowrap text-white opacity-0 shadow-md transition-opacity
				group-hover:opacity-100"
		>
			{label}
		</span>
	</div>
);
